<template>
	<header class="linha" :class="{ home: isHome }">
		<main-nav></main-nav>
		<div class="container">
			<div class="alignFix">
				<h1>
					<router-link to="/">
						<img src="@/assets/cia-autismo-logo.png" alt="CIA Autismo" />
					</router-link>
				</h1>
				<p v-if="isHome">Bem-vindo ao portal de dúvidas do Centro Integrado de Aprendizagem em Autismo (CIA Autismo). Aqui você poderá encontrar as mais diversas dúvidas frequentes sobre uso da plataforma, questões financeiras, conteúdo e mais.</p>
			</div>
		</div>
	</header>
</template>

<style lang="scss">
@import './../assets/sass/topo';
</style>

<script>
import mainNav from '@/components/mainNav.vue';
export default {
	name: 'topo',
	computed: {
		isHome() {
			return this.$store.getters.isHome;
		},
	},
	components: {
		mainNav,
	},
	mounted() {
		//console.log(this.$store.getters.isHome);
	},
};
</script>
